import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import styles from "./cookie-banner.module.css";
import { useCookieConsent } from "admin/hooks/use-cookie-consent";
import { UIIcon } from "PosterEditor/common-components/ui-icon-drawing/ui-icon";
import { usePaths } from "BEDROCK/paths";

export const CookieBanner = () => {
  const { markConsent, didConsent } = useCookieConsent();
  const [mounted, setMounted] = useState(false);
  const [visible, setVisible] = useState(false);
  const { navigateTo, home } = usePaths();

  useEffect(() => {
    setMounted(true);
    if (!didConsent) {
      setVisible(true);
    }
  }, []);

  useEffect(() => {
    if (didConsent) {
      setVisible(false);
    }
  }, [didConsent]);

  const handleAccept = () => {
    markConsent();
    setVisible(false);
  };

  const handleReject = () => {
    setVisible(false);
    navigateTo(home);
  };

  if (!mounted || !visible) return null;

  return createPortal(
    <div className={styles.overlay}>
      <div className={styles.banner}>
        <div className={styles.content}>
          <div className={styles.textContainer}>
            <h1 className={styles.title}>
              We use cookies to process your payment securely 🍪
            </h1>
            <p className={styles.body}>
              To complete your order, you need to accept the use of cookies
              required for payment processing. <br />
              You can change your options at any time.
            </p>
            <a className={styles.link} href="">
              See our cookie policy for more information
            </a>
          </div>
          <div className={styles.ctas}>
            <button className={styles.rejectButton} onClick={handleReject}>
              Reject and cancel
            </button>
            <button className={styles.acceptButton} onClick={handleAccept}>
              Accept
              <UIIcon iconName="CHEVRON-RIGHT" size={30} variant="CONTRAST" />
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};
